import Cookies from 'js-cookie';
import CoreFirebaseAPI from '../core/CoreFirebaseAPI';
import 'firebase/firebase-database';

class FirebaseNpsDeniedEmissionAPI {
  setApi(api) {
    this.api = api.getInstance();
  }

  getAPI(){
    if(!this.api) {
      const USER_ACCESS_COOKIE = 'uac';
      const { broker } = Cookies.getJSON(USER_ACCESS_COOKIE) || {};

      const url =`/nps/triggers/brokers/${broker && broker.externalId}/denied`;
      this.setApi(new CoreFirebaseAPI(url));
    }

    return this.api;
  }

  async getNotifications() {
    const response = await this.getAPI().once('value').then(snapshot => snapshot.val());
    return response;
  }
}

const api = new FirebaseNpsDeniedEmissionAPI();

export default api;
